import styled from '@emotion/styled'

interface BreakpointProps {
  BreakpointFromMedium: string
  BreakpointFromLarge: string
}

export const Container = styled.div(
  ({ BreakpointFromMedium, BreakpointFromLarge }: BreakpointProps) => ({
    padding: '0.75rem 0.75rem 0',
    width: '100%',
    maxWidth: '75rem',
    margin: '0 auto 1rem',
    display: 'flex',
    flexDirection: 'column-reverse',

    [BreakpointFromMedium]: {
      flexDirection: 'row',
      padding: '1rem 0 1rem 2rem',
      marginBottom: 0,
    },

    [BreakpointFromLarge]: {
      padding: '2.5rem 0 2.5rem 2rem',
    },
  }),
)

export const TextContainer = styled.div(
  ({ BreakpointFromMedium, BreakpointFromLarge }: BreakpointProps) => ({
    width: '100%',
    position: 'relative',
    textAlign: 'center',

    [BreakpointFromMedium]: {
      marginRight: '1.5rem',
      textAlign: 'left',
      maxWidth: '27rem',
      minWidth: '20rem',
    },

    [BreakpointFromLarge]: {
      maxWidth: '35rem',
      minWidth: '27rem',
    },
  }),
)

export const Title = styled.div(
  ({ BreakpointFromMedium, BreakpointFromLarge }: BreakpointProps) => ({
    marginBottom: '0.5rem',
    marginRight: '.25rem',

    [BreakpointFromMedium]: {
      marginBottom: '1rem',
      maxWidth: '22.5rem',
    },

    [BreakpointFromLarge]: {
      maxWidth: '32rem',
    },
  }),
)

export const SubTitle = styled.div({
  marginBottom: '1rem',
})
